import Vue from 'vue';
import Vuex from 'vuex';

import atualizalocal from './modules/atualizalocal';
import cache from './modules/cache';
import auth from './modules/auth';
import users from './modules/users';
import aberturalote from './modules/aberturalote';
import empresa from './modules/empresa';
import permissao from './modules/permissao';
import notafiscal from './modules/notafiscal';

import webpush from './modules/geral/webpush';
import visitatecnica from './modules/geral/visitatenica';

Vue.use(Vuex);

export default new Vuex.Store({
  actions: {
    async $_setup({ dispatch }) {
      await dispatch('auth/$_setup');
    },
  },

  modules: {
    atualizalocal,
    cache,
    auth,
    users,
    aberturalote,
    empresa,
    permissao,
    notafiscal,
    //
    webpush,
    visitatecnica,
  },
});
